import React, { FC, useEffect, useState } from "../../../lib/teact/teact";
import buildClassName from "../../../util/buildClassName";

import styles from '../../common/FullNameTitle.module.scss';
import "./contact.scss"
import DropdownMenu from "../../ui/DropdownMenu";
import MenuItem from "../../ui/MenuItem";
import store from "../store";
type LotContact = {

    curContact: any;
}
const LotContactItem: FC<LotContact> = ({

    curContact,
}) => {

    const [state, setState] = useState({
        extra: store.getState().contact.contactExtra[curContact.contactId]
    })
    useEffect(() => {
        const unsubscribe = store.subscribe(() => {
            const data: any = store.getState().contact.contactExtra
            const extra = data[curContact.contactId]
            if (extra != null && extra != undefined)
                setState(prev => ({ ...prev, extra: extra }))
        })
        return unsubscribe;
    }, [])
    return (

        <div className={buildClassName('contactItem')} style={"display:flex;width:100%"}>
            {/* //<div className="settings-main-header"> */}
            <div>
                <div >
                    {curContact.name}
                </div>
                <div className="extraInfo">
                    {curContact.phone}
                </div>
                {
                    state.extra &&
                    <div className="extraInfoEx">
                        {state.extra.mnCount > 0 && <div style="color:#a73953;font-weight:600;"> {" MN: " + state.extra.mnCount} </div>}
                        {state.extra.mtCount > 0 && <div style="color:#2c47ce;font-weight:600;"> {" MT: " + state.extra.mtCount}</div>}
                        {state.extra.mbCount > 0 && <div style="color:#ff5722;font-weight:600;"> {" MB: " + state.extra.mbCount}</div>}
                    </div>
                }
            </div>

        </div>
    )
}
export default LotContactItem